import { DropdownItem } from "@repo/ping-design";
import { Layer } from "../ts-types/policyTermsTypes";

export const NUMERAL_OPTIONS = {
  numeral: true,
  numeralThousandsGroupStyle: "thousand",
  numeralDecimalScale: 0,
  numeralPositiveOnly: true,
};

export const INITIAL_LAYERS: Layer[] = [];

export const PER_LOC_DED_TYPE_LABELS = {
  S: "Site Deductible",
  C: "Per Unit Coverage",
  CT: "Combined with Time Element",
  // CB: "Apply to Property Damage",
  PL: "Percent of Loss",
} as const;

export type PerLocDedTypeCode = keyof typeof PER_LOC_DED_TYPE_LABELS;

export const PERCENT_OF_LOSS_CODE: PerLocDedTypeCode = "PL";

export const LEGACY_PER_LOC_TYPE_MAP: Record<string, PerLocDedTypeCode> = {
  PCT: "PL",
  PERCENTAGE: "PL",
  FIXED: "S",
};

export const PER_LOC_DED_TYPE_OPTIONS: DropdownItem[] = [
  { label: "None", value: "" },
  ...Object.entries(PER_LOC_DED_TYPE_LABELS).map(([value, label]) => ({
    label,
    value,
  })),
];

export const MIN_LAYER_VALUE = 0;
export const MAX_LAYER_VALUE = 999_000_000;
export const MEGA_MULTIPLIER = 1_000_000;
export const MEGA_THRESHOLD_DIGITS = 4;

export const MIN_BI_DAYS_DEDUCTIBLE = 0;
export const MAX_BI_DAYS_DEDUCTIBLE = 365;
